import React from 'react';
import { Platform, useWindowDimensions } from 'react-native';
import { VStack } from '~/components/gluestack/vstack';
import { HStack } from '~/components/gluestack/hstack';
import { Text } from '~/components/gluestack/text';
import { Heading } from '~/components/gluestack/heading';
import { MemberDetails } from '~/models/MemberDetails';
import { PresenceIndicator } from '../members/PresenceIndicator';
import { CountryFlagIcon } from '~/components/ui/CountryFlagIcon';
import { useMeasurementFormatters } from '~/components/providers/MeasurementsProvider';

/** Content area below the status bar (username + location lines). */
export const PROFILE_MOBILE_HEADER_CONTENT_HEIGHT = 62;

export function useProfileMobileHeaderHeight(insetsTop: number, isLargeScreen: boolean) {
  const { fontScale } = useWindowDimensions();
  const contentHeight =
    Platform.OS === 'android'
      ? Math.ceil(PROFILE_MOBILE_HEADER_CONTENT_HEIGHT * fontScale)
      : PROFILE_MOBILE_HEADER_CONTENT_HEIGHT;
  return isLargeScreen ? 0 : contentHeight + insetsTop;
}

interface IProfileMobileHeaderProps {
  member: MemberDetails;
  title: string;
}

export function ProfileMobileHeader({ member, title }: IProfileMobileHeaderProps) {
  const { formatDistance } = useMeasurementFormatters();
  const formattedDistance = formatDistance(member.DistanceKm);

  return (
    <VStack className="native:gap-1 items-center web:gap-0">
      <HStack className="items-baseline gap-2">
        <Heading size="lg" className="text-white">
          {title}
        </Heading>
        <PresenceIndicator member={member} />
      </HStack>
      {(member.PlaceNameShort || member.CountryCode || formattedDistance) && (
        <HStack className="items-center gap-2">
          {member.CountryCode && <CountryFlagIcon countryCode={member.CountryCode} size={16} />}
          <Text className="text-white web:hover:underline" size="sm">
            {member.PlaceNameShort && formattedDistance
              ? `${member.PlaceNameShort} (${formattedDistance})`
              : member.PlaceNameShort || formattedDistance || ''}
          </Text>
        </HStack>
      )}
    </VStack>
  );
}


